const Web3 = require('web3');

let web3;

export default class Web3Connection {
    static async reconnect(rpcUrl) {
        web3 = new Web3(rpcUrl);
        const infoGetChainId = await web3.eth.getChainId();
        if (!infoGetChainId) {
            throw new Error(`Web3Connection: Failed to connect to the given URL: ${rpcUrl}`)
        }
    }

    static async connectToMetamask() {
        await global['ethereum'].enable();
        web3 = new Web3(global['web3'].currentProvider);
    }

    static async execute(callback) {
        await callback(web3);
    }

    static web3() {
        return web3;
    }

    static async defaultAccount() {
        return (await Web3Connection.web3().eth.getAccounts())[0];
    }

    static async rpcUrl() {
        return Web3Connection.web3().currentProvider.host;
    }
}
